import type { ReactNode } from 'react';
import { cn } from '@/core/lib/utils';

interface ToolbarProps {
  children: ReactNode;
  className?: string;
}

function ToolbarRoot({ children, className }: ToolbarProps) {
  return (
    <div className={cn('flex items-center justify-between gap-4 py-4', className)}>{children}</div>
  );
}

interface ToolbarInfoProps {
  title: string;
  description?: string;
  className?: string;
}

function ToolbarInfo({ title, description, className }: ToolbarInfoProps) {
  return (
    <div className={cn('flex flex-col', className)}>
      <h1 className="text-xl font-semibold">{title}</h1>
      {description && <p className="text-sm text-muted-foreground">{description}</p>}
    </div>
  );
}

interface ToolbarActionsProps {
  children: ReactNode;
  className?: string;
}

function ToolbarActions({ children, className }: ToolbarActionsProps) {
  return <div className={cn('flex items-center gap-2 ml-auto', className)}>{children}</div>;
}

ToolbarRoot.Info = ToolbarInfo;
ToolbarRoot.Actions = ToolbarActions;

export const Toolbar = ToolbarRoot;
